import React, { useEffect, useState, useRef } from "react";
import axios from '../../axios/axiosconf';

import { getHoraInicio, getHoraFin, normalizeFechaInput } from "../../../resources/Helper";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import Swal from 'sweetalert2';
import { usuarioTieneFirma, usuarioTieneRegistro, tiposDocumento, citaSeCruza, citaExistenteSeCruza } from "../../../resources/Helper";
import { usuarioPuedeIniciarAtencion } from "../../../utils/userAccessHelpers";
import { filtrarPacientesParaModal } from "../../../utils/busquedaPacienteFacturacion";
import { baseUrl } from "../../../resources/Constants";
import FormCitaPlanesPanel from "./FormCitaPlanesPanel";

/** Activar solo para depurar el formulario de cita en desarrollo. */
const DEBUG_FORM_NUEVA_CITA = false;
const formCitaDebug = (...args) => {
    if (DEBUG_FORM_NUEVA_CITA) console.log(...args);
};
const formCitaWarn = (...args) => {
    if (DEBUG_FORM_NUEVA_CITA) console.warn(...args);
};
const formCitaDebugErr = (...args) => {
    if (DEBUG_FORM_NUEVA_CITA) console.error(...args);
};

function FormNuevaCita(props) {

    const [modalContainerStatus, setModalContainerStatus] = useState('');
    const [modalBackdropStatus, setModalBackdropStatus] = useState('zindex-back');

    // Helper para mostrar warning de WhatsApp si el límite fue alcanzado
    const checkSmsWarning = (response) => {
        if (response.data && response.data.sms_warning) {
            const msg = response.data.sms_warning;
            const isLimite = msg.toLowerCase().includes('límite') || msg.toLowerCase().includes('limite');
            const isSinConfigurar = msg.toLowerCase().includes('sin límite') || msg.toLowerCase().includes('sin limite') || msg.toLowerCase().includes('no configurad') || msg.toLowerCase().includes('labsmobile');
            const isDesactivado = msg.toLowerCase().includes('desactivado');

            let title, html;
            if (isSinConfigurar) {
                title = 'SMS no disponible';
                html = '<p>La cita se registró exitosamente.</p><p>El envío de SMS (LabsMobile) no está configurado o no tiene cupo. Contacta al administrador.</p>';
            } else if (isLimite) {
                title = 'Cuota de SMS alcanzada';
                html = '<p>La cita se registró exitosamente, pero el SMS no pudo enviarse.</p><p>Se alcanzó el límite mensual de SMS para el cliente.</p>';
            } else if (isDesactivado) {
                title = 'SMS inactivo';
                html = '<p>La cita se registró exitosamente.</p><p>El servicio de SMS está desactivado para este cliente.</p>';
            } else {
                title = 'Aviso SMS';
                html = `<p>La cita se registró, pero hubo un inconveniente con el SMS:</p><p><small class="text-muted">${msg}</small></p>`;
            }

            Swal.fire({
                icon: 'info',
                title,
                html,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#3991b7'
            });
        }
    };

    const checkWhatsappWarning = (response) => {
        if (response.data && response.data.whatsapp_warning) {
            const msg = response.data.whatsapp_warning;
            const isLimite = msg.toLowerCase().includes('límite') || msg.toLowerCase().includes('limite');
            const isSinConfigurar = msg.toLowerCase().includes('sin límite') || msg.toLowerCase().includes('sin limite') || msg.toLowerCase().includes('no configurad');
            const isDesactivado = msg.toLowerCase().includes('desactivado');

            let title, html;
            if (isSinConfigurar) {
                title = 'Notificación no disponible';
                html = '<p>La cita se registró exitosamente.</p><p>Sin embargo, tu plan actual no incluye el envío de mensajes por WhatsApp. Contacta al administrador para habilitar este servicio.</p>';
            } else if (isLimite) {
                title = 'Cuota de mensajes alcanzada';
                html = '<p>La cita se registró exitosamente, pero el mensaje de WhatsApp no pudo ser enviado.</p><p>Has alcanzado el límite de mensajes permitidos para tu plan mensual.</p>';
            } else if (isDesactivado) {
                title = 'Servicio inactivo';
                html = '<p>La cita se registró exitosamente.</p><p>El servicio de notificaciones de WhatsApp está desactivado actualmente.</p>';
            } else {
                title = 'Aviso de notificación';
                html = `<p>La cita se registró, pero hubo un inconveniente con el envío de WhatsApp:</p><p><small class="text-muted">${msg}</small></p>`;
            }

            Swal.fire({
                icon: 'info',
                title,
                html,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#3991b7'
            });
        }
    };

    /** Avisos tras guardar: paciente existente, fallos de envío; WhatsApp usa el texto detallado si va solo. */
    const mostrarAvisosTrasGuardarCita = (response) => {
        const d = response?.data || {};

        // El warning de paciente se considera redundante ya que el sistema vincula automáticamente
        const tieneEnvioOWpp = Boolean(d.envio_warning || d.whatsapp_warning || d.sms_warning);

        if (!tieneEnvioOWpp) return;

        // Prioriza aviso específico de WhatsApp (cupo, desactivado, etc.)
        if (d.whatsapp_warning && !d.sms_warning) {
            checkWhatsappWarning(response);
            return;
        }

        if (!d.envio_warning && !d.whatsapp_warning && d.sms_warning) {
            checkSmsWarning(response);
            return;
        }

        const bloques = [];
        if (d.envio_warning && !d.whatsapp_warning) {
            bloques.push(
                `<div class="mb-3">
                    <strong>Error de Notificacion</strong><br/>
                    <small class="text-muted">La cita se registró correctamente, pero hubo un inconveniente al enviar la notificacion de la cita. Por favor, verifíquelo manualmente.</small>
                </div>`
            );
        }
        if (d.whatsapp_warning) {
            const msg = String(d.whatsapp_warning);
            const low = msg.toLowerCase();
            let detalleWpp = msg;
            if (low.includes('límite') || low.includes('limite') || low.includes('alcanzado')) {
                detalleWpp = 'Has alcanzado el límite de mensajes WhatsApp de tu plan mensual. La cita quedó registrada, pero no se envió la notificación.';
            } else if (low.includes('desactivado')) {
                detalleWpp = 'El servicio de WhatsApp está desactivado para este cliente. La cita quedó registrada sin notificación.';
            } else if (low.includes('sin límite') || low.includes('sin limite') || low.includes('no configurad')) {
                detalleWpp = 'Tu plan no incluye envío de WhatsApp o no está configurado. La cita quedó registrada sin notificación.';
            }
            bloques.push(
                `<div class="mb-2">
                    <strong>WhatsApp</strong><br/>
                    <small class="text-muted">${detalleWpp.replace(/</g, '&lt;')}</small>
                </div>`
            );
        }
        if (d.sms_warning) {
            bloques.push(
                `<div>
                    <strong>SMS</strong><br/>
                    <small class="text-muted">${String(d.sms_warning).replace(/</g, '&lt;')}</small>
                </div>`
            );
        }

        if (!bloques.length) return;

        Swal.fire({
            icon: 'info',
            title: 'Cita registrada con éxito',
            html: `<div class="text-left" style="font-size: 0.9rem;">${bloques.join('')}</div>`,
            confirmButtonText: 'Entendido',
            confirmButtonColor: '#3991b7'
        });
    };

    // Handler reutilizable para éxito al editar cita
    const handleEditCitaSuccess = (response) => {
        setLoading(false);
        mostrarAvisosTrasGuardarCita(response);
        props.reloadCitasAgenda();
        cerrar();
        resetForm();
    };
    const [loading, setLoading] = useState(false);
    const [estadosCita, setEstadosCita] = useState([]);
    const [unidadesAtencion, setUnidadesAtencion] = useState([]);

    const [idPacienteExistente, setIdPacienteExistente] = useState(props.idPacienteExistente || '-1');
    const [idCita, setIdCita] = useState(props.idCita || '');
    const [primerNombre, setPrimerNombre] = useState(props.primerNombre || '');
    const [segundoNombre, setSegundoNombre] = useState(props.segundoNombre || '');
    const [primerApellido, setPrimerApellido] = useState(props.primerApellido || '');
    const [segundoApellido, setSegundoApellido] = useState(props.segundoApellido || '');
    const [email, setEmail] = useState(props.email || '');
    const [celular, setCelular] = useState(props.celular || '');
    const [tipoDocumento, setTipoDocumento] = useState(props.tipoDocumento || '');
    const [numeroDocumento, setNumeroDocumento] = useState(props.numeroDocumento || '');

    const [fechaCita, setFechaCita] = useState(() => normalizeFechaInput(props.fecha || ''));
    const [idUsers, setIdUsers] = useState(props.profesionalAsignado || '');
    const [idUsuarioAsigna, setIdUsuarioAsigna] = useState(props.usuarioAsigna || '');
    const [horaAtencionCita, setHoraAtencionCita] = useState(props.horaAtencionCita || '');
    const [minutoCita, setMinutoCita] = useState(props.minutoCita || '');
    const [ampmCita, setAmpmCita] = useState(props.ampmCita || '');
    const [duracionCita, setDuracionCita] = useState(props.duracionCita || '');
    const [estadoCita, setEstadoCita] = useState(props.estadoCita || '');
    const [unidadAtencion, setUnidadAtencion] = useState(props.unidadAtencion || '');
    const [idConvenios, setIdConvenios] = useState(props.idConvenios || '');
    const [convenios, setConvenios] = useState([]);
    const [motivoConsulta, setMotivoConsulta] = useState(props.motivoConsulta || '');
    const [citaPaciente, setCitaPaciente] = useState(props.citaPaciente || '');


    const [nombreUsuarioAsigna, setNombreUsuarioAsigna] = useState(props.nombreUsuarioAsigna || '');
    const [puedeAtender, setPuedeAtender] = useState(props.puedeAtender || false);
    const [idPaciente, setIdPaciente] = useState(props.idPaciente || '');
    /** paciente.estado: 1 = anamnesis completa (historia/evolución); 0 = pendiente (completar anamnesis). */
    const [estadoPaciente, setEstadoPaciente] = useState(() =>
        props.estadoPaciente !== undefined && props.estadoPaciente !== null && props.estadoPaciente !== ''
            ? String(props.estadoPaciente)
            : ''
    );

    const [searchResults, setSearchResults] = useState([]);
    const [searchResultsState, setSearchResultsState] = useState('');
    const [listaPacientes, setListaPacientes] = useState([]);
    const [noResultado, setNoResultado] = useState('none');

    const [errorlist, setErrorlist] = useState({});
    /** Descarta respuestas viejas de citas-dia al cambiar hora/fecha o al reenviar. */
    const chequeoCruceSeqRef = useRef(0);
    const [verCita, setVerCita] = useState(props.verCita || false);
    const [primeraVez, setPrimeraVez] = useState(props.primeraVez || false);

    const [notificarWpp, setNotificarWpp] = useState(false);
    const [whatsappConfirmacionAuto, setWhatsappConfirmacionAuto] = useState(false);
    const [notificarSms, setNotificarSms] = useState(false);
    const [notificarEmail, setNotificarEmail] = useState(false);
    const [completarDatos, setCompletarDatos] = useState(false);
    const [crearPaciente, setCrearPaciente] = useState(false);
    const [estadoBtnAtender, setEstadoBtnAtender] = useState('hide');
    const [estadoBtnCompletar, setEstadoBtnCompletar] = useState('hide');
    const [idPacienteProximaCita, setIdPacienteProximaCita] = useState(props.agendarCitaPaciente || '');
    const [readOnlyProfesional, setReadOnlyProfesional] = useState(props.bloquearProfesional || false);
    const [readOnlyEstadoCita, setReadOnlyEstadoCita] = useState(props.bloquearEstadoCita || false);

    const [stepDuracionCita, setStepDuracionCita] = useState(props.stepCita || 15);
    const [permisos, setPermisos] = useState([]);
    const [agendas, setAgendas] = useState([]);
    /** Datos del cliente para texto de remitente en WhatsApp (nombre_comercial, teléfonos). */
    const [clientParaWpp, setClientParaWpp] = useState(null);
    let history = useHistory();

    const [showModalCompletarInfo, setShowModalCompletarInfo] = useState(false);
    const [pestanaForm, setPestanaForm] = useState('cita');
    const [planConsumo, setPlanConsumo] = useState(null);
    /** Última pestaña de planes visitada: el panel permanece montado al volver a Cita. */
    const [ultimaPestanaPlanes, setUltimaPestanaPlanes] = useState('gestionar_planes');
    const [mantenerPanelPlanes, setMantenerPanelPlanes] = useState(false);

    const refPrimerNombre = useRef();
    const refSegundoNombre = useRef();
    const refPrimerApellido = useRef();
    const refSegundoApellido = useRef();
    const refDocumento = useRef();
    const refTipoDocumento = useRef();
    const refEmail = useRef();
    const refCelular = useRef();
    const refBusquedaPaciente = useRef(null);
    const citaOriginalRef = useRef(null);
    /** Estado guardado en BD al abrir el modal (no cambia al mover el dropdown). */
    const estadoCitaPersistidoRef = useRef(null);

    function handleNotificarWpp() {
        setNotificarWpp(prev => {
            const next = !prev;
            // WhatsApp y SMS son excluyentes para evitar envíos ambiguos.
            if (next) setNotificarSms(false);
            return next;
        });
    }

    /** estado_smile 0 (Asignada) o 6 (Reasignada) → plantilla con botones de confirmación. */
    const estadoRequiereConfirmacionWhatsapp = (estadoId) => {
        if (!estadoId || !Array.isArray(estadosCita) || !estadosCita.length) return false;
        const est = estadosCita.find((e) => String(e.id) === String(estadoId));
        if (!est || est.estado_smile === undefined || est.estado_smile === null) return false;
        const smile = Number(est.estado_smile);
        return smile === 0 || smile === 6;
    };

    const limpiarErrorCampo = (...campos) => {
        if (campos.some((c) => c === 'hora_atencion_cita' || c === 'fecha_cita' || c === 'duracion_cita' || c === 'id_users' || c === 'id_unidad')) {
            chequeoCruceSeqRef.current += 1;
            setLoading(false);
        }
        setErrorlist((prev) => {
            if (!prev || typeof prev !== 'object') return prev;
            let changed = false;
            const next = { ...prev };
            campos.forEach((campo) => {
                if (Object.prototype.hasOwnProperty.call(next, campo)) {
                    delete next[campo];
                    changed = true;
                }
            });
            return changed ? next : prev;
        });
    };

    const handleEstadoCitaChange = (estadoId) => {
        setEstadoCita(estadoId);
        limpiarErrorCampo('estado_cita');
        const requiereConfirmacion = estadoRequiereConfirmacionWhatsapp(estadoId);
        setWhatsappConfirmacionAuto(requiereConfirmacion);
    };

    function handleNotificarSms() {
        setNotificarSms(prev => {
            const next = !prev;
            // WhatsApp y SMS son excluyentes para evitar envíos ambiguos.
            if (next) setNotificarWpp(false);
            return next;
        });
    }

    function handleNotificarEmail() {
        setNotificarEmail(prev => !prev);
    }

    const getNombreAsuntoCentral = () => {
        const full = [primerNombre, segundoNombre, primerApellido, segundoApellido]
            .filter(Boolean)
            .map((v) => String(v).trim())
            .filter(Boolean)
            .join(' ')
            .replace(/\s+/g, ' ')
            .trim();
        return full || (primerNombre || '').trim();
    };

    const strWpp = (v) => {
        if (v === undefined || v === null) return '';
        const s = String(v).trim();
        return s;
    };

    /** Misma prioridad que el backend: agenda (nombre_ms / telefono_ms) y si no, cliente. */
    const getRemitenteWhatsappParaCita = () => {
        const agenda = agendas.find((a) => String(a.id) === String(idUsers));
        let nombre = '';
        let tel = '';
        if (agenda) {
            nombre = strWpp(agenda.nombre_ms);
            tel = strWpp(agenda.telefono_ms);
        }
        const c = clientParaWpp;
        if (c) {
            if (!nombre) nombre = strWpp(c.nombre_comercial) || strWpp(c.nombre);
            if (!tel) tel = strWpp(c.telefono_contacto) || strWpp(c.telefono);
        }
        return { nombre, tel };
    };

    const firmaTextoWhatsapp = () => {
        const { nombre, tel } = getRemitenteWhatsappParaCita();
        const partes = [];
        if (nombre) partes.push(nombre);
        if (tel) partes.push(`Tel: ${tel}`);
        return partes.length ? `\n\n${partes.join('\n')}` : '';
    };

    const construirMensajeWppNueva = () =>
        `Hola ${primerNombre}, te confirmamos tu cita para el ${fechaCita} a las ${horaAtencionCita}:${minutoCita} ${ampmCita.toUpperCase()}. ¡Te esperamos!${firmaTextoWhatsapp()}`;

    const construirMensajeWppEdicion = () =>
        `Hola ${primerNombre}, tu cita ha sido reprogramada para el ${fechaCita} a las ${horaAtencionCita}:${minutoCita} ${ampmCita.toUpperCase()}. Por favor confirma tu asistencia.${firmaTextoWhatsapp()}`;

    const getBadgeEstadoStyle = () => {
        const fallback = {
            backgroundColor: 'rgba(23, 162, 184, 0.14)',
            color: '#12889a',
            border: '1px solid rgba(23, 162, 184, 0.28)',
            borderRadius: '999px',
            fontWeight: 700,
            fontSize: '0.74rem',
            padding: '0.2rem 0.6rem',
            whiteSpace: 'nowrap',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px'
        };
        if (!estadoCita || !Array.isArray(estadosCita)) return { ...fallback, display: 'none' };

        const est = estadosCita.find(e => String(e.id) === String(estadoCita));
        if (!est) return { ...fallback, display: 'none' };

        return {
            ...fallback,
            backgroundColor: est.color ? `${est.color}15` : fallback.backgroundColor,
            color: '#3a4654',
            border: est.color ? `1px solid ${est.color}60` : fallback.border,
            display: 'inline-flex'
        };
    };

    const getNombreEstadoActual = () => {
        if (!estadoCita || !estadosCita.length) return '';
        const est = estadosCita.find(e => String(e.id) === String(estadoCita));
        return est ? est.nombre : '';
    };

    const getColorEstadoActual = () => {
        if (!estadoCita || !estadosCita.length) return '#3991b7';
        const est = estadosCita.find(e => String(e.id) === String(estadoCita));
        return est ? est.color : '#3991b7';
    };

    /** estado_smile 2 = Atendida, 3 = No cumplida (solo el estado ya guardado). */
    const getEstadoSmilePersistido = () => {
        const estadoId = estadoCitaPersistidoRef.current;
        if (!estadoId || !Array.isArray(estadosCita) || !estadosCita.length) return null;
        const est = estadosCita.find((e) => String(e.id) === String(estadoId));
        if (!est || est.estado_smile === null || est.estado_smile === undefined || est.estado_smile === '') return null;
        const n = Number(est.estado_smile);
        return Number.isNaN(n) ? null : n;
    };

    const citaPersistidaEstaAtendida = () => getEstadoSmilePersistido() === 2;
    const citaPersistidaEstaNoCumplida = () => getEstadoSmilePersistido() === 3;

    const formSoloLectura = verCita && (citaPersistidaEstaAtendida() || citaPersistidaEstaNoCumplida());

    const motivoSoloLecturaCita = citaPersistidaEstaAtendida()
        ? 'atendida'
        : (citaPersistidaEstaNoCumplida() ? 'no_cumplida' : null);

    const hayErrorCampo = (campo) => {
        if (!errorlist || typeof errorlist !== 'object') return false;
        return Object.prototype.hasOwnProperty.call(errorlist, campo);
    };

    const manejarErrorGuardarCita = (error, fallbackTitle = 'Error al guardar') => {
        setLoading(false);
        const status = error?.response?.status;
        const data = error?.response?.data || {};
        if (status === 422 && data.errors) {
            setErrorlist(data.errors);
            irAPestanaDeErrores(data.errors);
            const msgs = Object.values(data.errors)
                .flat()
                .filter(Boolean)
                .slice(0, 5);
            Swal.fire({
                icon: 'warning',
                title: 'Revise los datos',
                html: `<div class="text-left">${msgs.map((m) => `<p class="mb-1">• ${String(m).replace(/</g, '&lt;')}</p>`).join('')}</div>`,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#3085d6'
            });
            return;
        }
        setErrorlist({});
        Swal.fire({
            icon: 'error',
            title: fallbackTitle,
            text: data.message || 'No se pudo guardar la cita. Intenta de nuevo.',
            confirmButtonText: 'Entendido',
            confirmButtonColor: '#3085d6'
        });
    };

    const irAPestanaDeErrores = (errores) => {
        const keys = Object.keys(errores || {});
        if (!keys.length) return;
        const esCampoPlanes = keys.some((k) => ['id_paciente', 'plan_consumo'].includes(k));
        const esCampoCita = keys.some((k) =>
            ['primer_nombre', 'fecha_cita', 'hora_atencion_cita', 'duracion_cita', 'estado_cita', 'id_users', 'celular', 'email', 'tipo_documento', 'numero_documento', 'cita_celular', 'telefono'].includes(k)
        );
        if (esCampoPlanes && (pestanaForm === 'planes' || pestanaForm === 'gestionar_planes') && keys.every((k) => ['id_paciente', 'plan_consumo'].includes(k))) {
            return;
        }
        if (esCampoCita) {
            setPestanaForm('cita');
            return;
        }
        if (esCampoPlanes && pestanaForm === 'cita') {
            setPestanaForm('gestionar_planes');
        }
    };

    const textoError = (valor) => {
        if (valor == null || valor === '') return '';
        if (Array.isArray(valor)) return valor.filter(Boolean).join(' ');
        return String(valor);
    };

    // Oculta el formulario de cita
    const cerrar = () => {
        setModalContainerStatus('');
        setModalBackdropStatus('zindex-back');
        resetForm();
        props.closeModal();
    }

    // Muestra el formulario de cita
    const show = () => {
        setModalContainerStatus('show');
        setModalBackdropStatus('show');
    }

    /**
     * La validación de cruce NO debe contar citas en estados ocultos en agenda
     * (ej: Cancelada con ocultar_agenda = 1), porque ya liberaron ese horario.
     */
    const estadoOcultaAgenda = (cita) => {
        if (!cita) return false;
        const ext = cita.extendedProps || {};

        const ocultarDirecto = cita.ocultar_agenda ?? ext.ocultar_agenda;
        if (ocultarDirecto !== undefined && ocultarDirecto !== null && ocultarDirecto !== '') {
            return Number(ocultarDirecto) === 1;
        }

        const estadoId =
            cita.id_estado ??
            cita.id_estado_cita ??
            cita.estado_cita ??
            ext.id_estado ??
            ext.id_estado_cita ??
            ext.estado_cita;

        if (estadoId === undefined || estadoId === null || estadoId === '') {
            return false;
        }

        const estado = estadosCita.find((e) => String(e.id) === String(estadoId));
        if (!estado) return false;

        return Number(estado.ocultar_agenda || 0) === 1;
    };

    const filtrarCitasVisiblesParaCruce = (citas) =>
        (Array.isArray(citas) ? citas : []).filter((cita) => !estadoOcultaAgenda(cita));

    const normalizarUnidadCruce = (v) => {
        const s = String(v ?? '').trim();
        if (s === '' || s === '-' || s === '0' || s.toLowerCase() === 'null' || s.toLowerCase() === 'undefined') {
            return '';
        }
        return s;
    };

    /**
     * Regla de cruce por unidad:
     * - Si la cita nueva/editada tiene unidad, solo cruza contra esa misma unidad.
     * - Si la cita nueva/editada NO tiene unidad, solo cruza contra citas sin unidad.
     *   (No bloquear por citas que sí tienen unidad asignada).
     */
    const filtrarCitasParaCrucePorUnidad = (citas, unidadObjetivo) => {
        const lista = filtrarCitasVisiblesParaCruce(citas);
        const unidadObjNorm = normalizarUnidadCruce(unidadObjetivo);
        return lista.filter((cita) => {
            const unidadCitaNorm = normalizarUnidadCruce(cita?.id_unidad_atencion);
            if (!unidadObjNorm) return unidadCitaNorm === '';
            return unidadCitaNorm === unidadObjNorm;
        });
    };

    const citaNuevaSeCruzaConVisibles = (fecha, hora, duracion, citas, unidadObjetivo = null) =>
        citaSeCruza(fecha, hora, duracion, filtrarCitasParaCrucePorUnidad(citas, unidadObjetivo));

    const citaEditSeCruzaConVisibles = (fecha, hora, duracion, idCitaActual, citas, unidadObjetivo = null) =>
        citaExistenteSeCruza(fecha, hora, duracion, idCitaActual, filtrarCitasParaCrucePorUnidad(citas, unidadObjetivo));

    // Función para guardar la cita
    const guardarCita = (userdata, hc) => {
        const conf = {
            client_id: userdata.client_id,
            primer_nombre: primerNombre,
            segundo_nombre: segundoNombre,
            primer_apellido: primerApellido,
            segundo_apellido: segundoApellido,
            email: email,
            celular: celular,
            tipo_documento: tipoDocumento,
            numero_documento: numeroDocumento,

            fecha_cita: fechaCita,
            hora_atencion_cita: horaAtencionCita,
            minuto_cita: minutoCita,
            ampm: ampmCita,
            hora_cita: hc,
            duracion_cita: duracionCita,
            estado_cita: estadoCita,
            id_users: idUsers,
            id_usuario_asigna: idUsuarioAsigna || userdata.user_id,
            id_unidad_atencion: unidadAtencion,
            id_convenios: idConvenios || null,
            motivo_consulta: motivoConsulta,

            cita_paciente: getNombreAsuntoCentral(),
            cita_email: email || '',
            cita_telefono: celular || '',
            cita_celular: celular || '',
            id_paciente_existente: idPacienteExistente !== '-1' ? idPacienteExistente : (idPaciente || '-1'),
            id_paciente_proxima_cita: idPacienteProximaCita,

            notificar_wpp: notificarWpp ? 1 : 0,
            notificar_sms: notificarSms ? 1 : 0,
            notificar_email: notificarEmail ? 1 : 0,
            completar_datos: (pestanaForm === 'planes' || pestanaForm === 'gestionar_planes') ? 0 : (completarDatos ? 1 : 0),
            crear_paciente: (pestanaForm === 'planes' || pestanaForm === 'gestionar_planes') ? 0 : ((crearPaciente || completarDatos) ? 1 : 0),
            tipo_cita_default: 0,

            id_persona: userdata.id_persona,
            id_cliente_escritorio: userdata.id_cliente_escritorio,

            mensaje_wpp: construirMensajeWppNueva()
        };

        if (planConsumo) {
            // Se envía aunque todas las sesiones estén en 0 (cita sin descontar cupo)
            conf.plan_consumo = planConsumo;
        }

        axios.post('/cita', conf)
            .then(response => {
                setLoading(false);
                mostrarAvisosTrasGuardarCita(response);
                localStorage.setItem('msgtoast', 'La cita ha sido agendada.');
                props.reloadCitasAgenda();
                resetForm();
                cerrar();
            })
            .catch(error => {
                manejarErrorGuardarCita(error);
            });
    }

    // Handler para cuando se guarda una cita nueva o una existente
    const handleSubmit = (e) => {
        e.preventDefault();

        if (formSoloLectura) {
            const tituloBloqueo = citaPersistidaEstaNoCumplida() ? 'Cita no cumplida' : 'Cita atendida';
            const textoBloqueo = citaPersistidaEstaNoCumplida()
                ? 'Esta cita está en estado No cumplida y no puede modificarse.'
                : 'Esta cita ya fue atendida y no puede modificarse.';
            Swal.fire({
                icon: 'info',
                title: tituloBloqueo,
                text: textoBloqueo,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#3991b7'
            });
            return;
        }

        // Validación estandarizada (único formulario)
        const erroresFront = {};
        const addError = (key, msg) => {
            if (!erroresFront[key]) erroresFront[key] = [];
            erroresFront[key].push(msg);
        };

        if (!(primerNombre || '').trim()) addError('primer_nombre', 'Campo obligatorio: Primer nombre / asunto');
        const nombreCompleto = getNombreAsuntoCentral();
        if (nombreCompleto.length > 120) {
            addError('primer_nombre', 'El nombre/asunto completo no puede superar 120 caracteres (suma de nombre y apellidos).');
        }
        if (!fechaCita) addError('fecha_cita', 'Campo obligatorio: Fecha');
        if (!horaAtencionCita || !minutoCita || !ampmCita) addError('hora_atencion_cita', 'Campo obligatorio: Hora');
        if (!estadoCita) addError('estado_cita', 'Campo obligatorio: Estado de la cita');
        const durNum = duracionCita === '' || duracionCita == null ? NaN : Number(duracionCita);
        if (!Number.isFinite(durNum) || durNum < 1) {
            addError('duracion_cita', 'Campo obligatorio: Duración');
        }
        if (!idUsers) addError('id_users', 'Campo obligatorio: Agenda asignada');

        if (pestanaForm === 'planes' || pestanaForm === 'gestionar_planes') {
            if (!idPaciente) {
                addError('id_paciente', pestanaForm === 'gestionar_planes'
                    ? 'En Planes debe seleccionar un paciente existente'
                    : 'En Asignar plan debe seleccionar un paciente existente');
            }
        } else {
            const requiereCrearPaciente = Boolean(crearPaciente || completarDatos);
            if (requiereCrearPaciente) {
                if (!tipoDocumento) addError('tipo_documento', 'Para crear paciente, el tipo de documento es obligatorio');
                if (!(numeroDocumento || '').trim()) addError('numero_documento', 'Para crear paciente, el número de documento es obligatorio');
            }

            if (completarDatos && !(email || '').trim()) {
                addError('email', 'Para completar datos, el email es obligatorio');
            }
        }

        if (notificarEmail && !(email || '').trim()) {
            addError('email', 'Para notificar por email, debes ingresar el correo');
        }

        if (notificarWpp && !(celular || '').trim()) {
            addError('celular', 'Para notificar por WhatsApp, debes ingresar celular');
        }
        if (notificarSms && !(celular || '').trim()) {
            addError('celular', 'Para notificar por SMS, debes ingresar celular');
        }
        const celTrim = (celular || '').trim();
        if (celTrim && celTrim.length > 15) {
            addError('celular', 'El celular no puede superar 15 caracteres. Acórtelo e intente de nuevo.');
        }

        if (Object.keys(erroresFront).length > 0) {
            setErrorlist(erroresFront);
            irAPestanaDeErrores(erroresFront);
            const msgs = Object.values(erroresFront).flat().filter(Boolean).slice(0, 5);
            Swal.fire({
                icon: 'warning',
                title: 'Faltan datos por completar',
                html: `<div class="text-left">${msgs.map((m) => `<p class="mb-1">• ${String(m).replace(/</g, '&lt;')}</p>`).join('')}</div>`,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#3085d6'
            });
            return;
        }

        // Limpia alertas de cruce previas; la validación de servidor se reevalúa con la hora actual
        setErrorlist({});
        const chequeoId = ++chequeoCruceSeqRef.current;
        const chequeoCruceVigente = () => chequeoId === chequeoCruceSeqRef.current;
        formCitaDebug('Iniciando guardado...');
        setLoading(true);
        let userdata = [];

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        let hora24 = horaAtencionCita;
        if (ampmCita === 'pm' && parseInt(horaAtencionCita) < 12) {
            hora24 = parseInt(horaAtencionCita) + 12;
        } else if (ampmCita === 'am' && horaAtencionCita === '12') {
            hora24 = '00';
        }

        let hc = `${hora24.toString().padStart(2, '0')}:${minutoCita}:00`;

        // Si la cita es nueva...
        if (!verCita) {
            let citasDia = [];
            const conf2 = {
                headers: { Authorization: 'Bearer ' + userdata.access_token },
                params: { uid: idUsers, fecha: fechaCita }
            };

            // Se verifica que la nueva cita no se cruce con otra ya existente...
            axios.get('citas-dia-profesional', conf2)
                .then(response => {
                    if (!chequeoCruceVigente()) return;
                    citasDia = response.data;
                    // Si la nueva cita no se cruza con otra, agendar la nueva cita...
                    if (!citaNuevaSeCruzaConVisibles(fechaCita, hc, duracionCita, citasDia, unidadAtencion)) {

                        // Verificar unidad solo si está seleccionada
                        if (unidadAtencion) {
                            let citasDiaUnidad = [];
                            const conf3 = {
                                headers: { Authorization: 'Bearer ' + userdata.access_token },
                                params: { id_unidad: unidadAtencion, fecha: fechaCita }
                            };

                            axios.get('citas-dia-unidad', conf3)
                                .then(response => {
                                    if (!chequeoCruceVigente()) return;
                                    citasDiaUnidad = response.data;
                                    if (!citaNuevaSeCruzaConVisibles(fechaCita, hc, duracionCita, citasDiaUnidad, unidadAtencion)) {
                                        guardarCita(userdata, hc);
                                    } else {
                                        setLoading(false);
                                        setErrorlist({ id_unidad: 'La unidad de atención seleccionada está ocupada en este horario' });
                                    }
                                })
                                .catch(error => {
                                    if (!chequeoCruceVigente()) return;
                                    formCitaDebug('Error verificando unidad:', error);
                                    // Si hay error, proceder igual
                                    guardarCita(userdata, hc);
                                });
                        } else {
                            // Si no hay unidad seleccionada, proceder directamente
                            guardarCita(userdata, hc);
                        }
                    } else {
                        setLoading(false);
                        setErrorlist({ hora_atencion_cita: 'La cita se cruza con otra cita ya existente' });
                    }
                })
                .catch(error => {
                    if (!chequeoCruceVigente()) return;
                    formCitaDebug('Error verificando profesional:', error);
                    // Si hay error, verificar unidad si está seleccionada
                    if (unidadAtencion) {
                        let citasDiaUnidad = [];
                        const conf3 = {
                            headers: { Authorization: 'Bearer ' + userdata.access_token },
                            params: { id_unidad: unidadAtencion, fecha: fechaCita }
                        };

                        axios.get('citas-dia-unidad', conf3)
                            .then(response => {
                                if (!chequeoCruceVigente()) return;
                                citasDiaUnidad = response.data;
                                if (!citaNuevaSeCruzaConVisibles(fechaCita, hc, duracionCita, citasDiaUnidad, unidadAtencion)) {
                                    guardarCita(userdata, hc);
                                } else {
                                    setLoading(false);
                                    setErrorlist({ id_unidad: 'La unidad de atención seleccionada está ocupada en este horario' });
                                }
                            })
                            .catch(error => {
                                if (!chequeoCruceVigente()) return;
                                formCitaDebug('Error verificando unidad:', error);
                                // Si hay error en ambas verificaciones, proceder igual
                                guardarCita(userdata, hc);
                            });
                    } else {
                        // Si no hay unidad seleccionada, proceder directamente
                        guardarCita(userdata, hc);
                    }
                });
        } else {
            // Si se está modificando una cita ya existente...
            let hora24Edit = horaAtencionCita;
            if (ampmCita === 'pm' && parseInt(horaAtencionCita) < 12) {
                hora24Edit = parseInt(horaAtencionCita) + 12;
            } else if (ampmCita === 'am' && horaAtencionCita === '12') {
                hora24Edit = '00';
            }

            let hc = `${hora24Edit.toString().padStart(2, '0')}:${minutoCita}:00`;

            const conf = {
                id: idCita,
                primer_nombre: primerNombre,
                segundo_nombre: segundoNombre,
                primer_apellido: primerApellido,
                segundo_apellido: segundoApellido,
                tipo_documento: tipoDocumento,
                numero_documento: numeroDocumento,
                email: email || '',
                celular: celular || '',
                fecha_cita: fechaCita,
                hora_atencion_cita: horaAtencionCita,
                minuto_cita: minutoCita,
                ampm: ampmCita,
                hora_cita: hc,
                duracion_cita: duracionCita,
                estado_cita: estadoCita,
                id_users: idUsers,
                id_usuario_asigna: idUsuarioAsigna,
                id_unidad_atencion: unidadAtencion || null,
                id_convenios: idConvenios || null,
                motivo_consulta: motivoConsulta,

                cita_paciente: getNombreAsuntoCentral(),
                cita_email: email || '',
                cita_telefono: celular || '',
                cita_celular: celular || '',

                id_persona: userdata.id_persona,
                id_cliente_escritorio: userdata.id_cliente_escritorio,
                id_paciente_existente: idPacienteExistente !== '-1' ? idPacienteExistente : (idPaciente || '-1'),

                notificar_wpp: notificarWpp ? 1 : 0,
                notificar_sms: notificarSms ? 1 : 0,
                notificar_email: notificarEmail ? 1 : 0,
                completar_datos: completarDatos ? 1 : 0,
                crear_paciente: (crearPaciente || completarDatos) ? 1 : 0,
                tipo_cita_default: 0,
                mensaje_wpp: construirMensajeWppEdicion()
            };

            if (planConsumo) {
                conf.plan_consumo = planConsumo;
            }

            let citasDia = [];
            const conf2 = { headers: { Authorization: 'Bearer ' + userdata.access_token }, params: { uid: idUsers, fecha: fechaCita } };


            formCitaDebug('📤 Datos enviados al backend:', JSON.stringify(conf, null, 2));
            axios.get('citas-dia-profesional', conf2)
                .then(response => {
                    if (!chequeoCruceVigente()) return;
                    citasDia = response.data;
                    if (!citaEditSeCruzaConVisibles(fechaCita, hc, duracionCita, idCita, citasDia, unidadAtencion)) {

                        if (unidadAtencion) {
                            let citasDiaUnidad = [];
                            const conf3 = { headers: { Authorization: 'Bearer ' + userdata.access_token }, params: { id_unidad: unidadAtencion, fecha: fechaCita } };

                            axios.get('citas-dia-unidad', conf3)
                                .then(response => {
                                    if (!chequeoCruceVigente()) return;
                                    citasDiaUnidad = response.data;
                                    if (!citaEditSeCruzaConVisibles(fechaCita, hc, duracionCita, idCita, citasDiaUnidad, unidadAtencion)) {
                                        axios.put('/cita', conf)
                                            .then(handleEditCitaSuccess)
                                            .catch((err) => {
                                                formCitaDebug(err.response?.data);
                                                manejarErrorGuardarCita(err);
                                            });
                                    } else {
                                        setLoading(false);
                                        setErrorlist({ id_unidad: 'La unidad de atención seleccionada está ocupada en este horario' });
                                    }
                                })
                                .catch(error => {
                                    if (!chequeoCruceVigente()) return;
                                    formCitaDebug('Error verificando unidad:', error);
                                    axios.put('/cita', conf)
                                        .then(handleEditCitaSuccess)
                                        .catch(err => {
                                            formCitaDebug(err.response?.data);
                                            manejarErrorGuardarCita(err);
                                        });
                                });
                        } else {
                            axios.put('/cita', conf)
                                .then(handleEditCitaSuccess)
                                .catch((error) => manejarErrorGuardarCita(error));
                        }
                    } else {
                        setLoading(false);
                        setErrorlist({ hora_atencion_cita: 'La cita se cruza con otra cita ya existente' });
                    }
                })
                .catch(error => {
                    if (!chequeoCruceVigente()) return;
                    formCitaDebug('Error verificando profesional:', error);
                    if (unidadAtencion) {
                        let citasDiaUnidad = [];
                        const conf3 = { headers: { Authorization: 'Bearer ' + userdata.access_token }, params: { id_unidad: unidadAtencion, fecha: fechaCita } };

                        axios.get('citas-dia-unidad', conf3)
                            .then(response => {
                                if (!chequeoCruceVigente()) return;
                                citasDiaUnidad = response.data;
                                if (!citaEditSeCruzaConVisibles(fechaCita, hc, duracionCita, idCita, citasDiaUnidad, unidadAtencion)) {
                                    axios.put('/cita', conf)
                                        .then(handleEditCitaSuccess)
                                        .catch(err => {
                                            formCitaDebug(err.response?.data);
                                            manejarErrorGuardarCita(err);
                                        });
                                } else {
                                    setLoading(false);
                                    setErrorlist({ id_unidad: 'La unidad de atención seleccionada está ocupada en este horario' });
                                }
                            })
                            .catch(error => {
                                if (!chequeoCruceVigente()) return;
                                formCitaDebug('Error verificando unidad:', error);
                                axios.put('/cita', conf)
                                    .then(handleEditCitaSuccess)
                                    .catch(err => {
                                        formCitaDebug(err.response?.data);
                                        manejarErrorGuardarCita(err);
                                    });
                            });
                    } else {
                        axios.put('/cita', conf)
                            .then(handleEditCitaSuccess)
                            .catch((err) => {
                                formCitaDebug(err.response?.data);
                                manejarErrorGuardarCita(err);
                            });
                    }
                });
        }
    }

    // Cuando el componente se renderiza se cargan maestros necesarios
    // Cuando el componente se renderiza se cargan maestros necesarios
    useEffect(() => {
        let cancelled = false;
        let userdata = [];

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setPermisos(userdata.up || []);
            // idUsuarioAsigna se define al abrir el modal (cita nueva vs edición), no aquí.

            // 🔒 Usar axios que ya tiene el token configurado
            Promise.all([
                axios.get('/estados-cita').catch(err => { formCitaDebug('Error estados:', err); return { data: [] }; }),
                axios.get('/unidades-atencion').catch(err => { formCitaDebug('Error unidades:', err); return { data: [] }; }),
                axios.get('/agendas-usuario').catch(err => { formCitaDebug('Error agendas:', err); return { data: [] }; }),
                axios.get('/get-client?uid=' + userdata.user_id).catch(err => { formCitaDebug('Error client wpp:', err); return { data: null }; }),
                axios.get('/convenios').catch(err => { formCitaDebug('Error convenios:', err); return { data: [] }; }),
                axios.get('/pacientes', { params: { uid: userdata.user_id } }).catch(err => { formCitaDebug('Error pacientes:', err); return { data: [] }; })
            ])
                .then(([estadosRes, unidadesRes, agendasRes, clientRes, conveniosRes, pacientesRes]) => {
                    if (cancelled) return;
                    const estados = estadosRes.data || [];
                    const unidades = unidadesRes.data || [];
                    const agendas = agendasRes.data || [];
                    const listaConvenios = conveniosRes.data || [];
                    const pacientes = pacientesRes.data || [];

                    setEstadosCita(estados);
                    setUnidadesAtencion(unidades);
                    setAgendas(agendas);
                    setConvenios(listaConvenios);
                    setListaPacientes(pacientes);
                    if (clientRes && clientRes.data) {
                        setClientParaWpp(clientRes.data);
                    }

                    // Set default state if not already set
                    if (!estadoCita && estados.length > 0) {
                        setEstadoCita(estados[0].id);
                    }
                })
                .catch(error => {
                    if (!cancelled) formCitaDebugErr('Error loading data:', error);
                });
        }
        return () => { cancelled = true; };
    }, []);

    // Sincronizar formulario con lo que envía Agenda (clic en cita / slot).
    // Importante: NO depender de `agendas` ni `estadosCita` aquí — cuando esos arrays
    // cargan después, este efecto volvía a ejecutarse y pisaba nombre/apellidos tras
    // elegir un paciente en el buscador (el padre sigue con strings vacíos).
    useEffect(() => {
        if (props.modalState == 'visible') {
            show();

            setNotificarWpp(false);
            setNotificarSms(false);
            setNotificarEmail(false);
            setWhatsappConfirmacionAuto(false);

            setIdCita(props.idCita || '');
            setPrimerNombre(props.primerNombre || '');
            setSegundoNombre(props.segundoNombre || '');
            setPrimerApellido(props.primerApellido || '');
            setSegundoApellido(props.segundoApellido || '');
            setEmail(props.email || '');
            setCelular(props.celular || '');
            setTipoDocumento(props.tipoDocumento || '');
            setNumeroDocumento(props.numeroDocumento || '');

            setDuracionCita(props.duracionCita || '');
            // El default del primer estado lo aplica un efecto aparte cuando cargan `estadosCita`.
            setEstadoCita(
                props.estadoCita !== undefined && props.estadoCita !== null && props.estadoCita !== ''
                    ? props.estadoCita
                    : ''
            );
            setUnidadAtencion(props.unidadAtencion || '');
            setIdConvenios(props.idConvenios != null && props.idConvenios !== '' ? String(props.idConvenios) : '');
            setMotivoConsulta(props.motivoConsulta || '');
            setCitaPaciente(props.citaPaciente || '');

            setFechaCita(normalizeFechaInput(props.fecha || ''));

            setHoraAtencionCita(props.horaAtencionCita || '');
            setMinutoCita(props.minutoCita || '');
            setAmpmCita(props.ampmCita || '');

            setVerCita(props.verCita || false);
            setPuedeAtender(props.puedeAtender || false);
            const pacienteIdModal =
                props.idPaciente !== undefined && props.idPaciente !== null && props.idPaciente !== ''
                    ? String(props.idPaciente)
                    : '';
            setIdPaciente(pacienteIdModal);
            const pacienteExistenteModal =
                props.idPacienteExistente !== undefined
                && props.idPacienteExistente !== null
                && props.idPacienteExistente !== ''
                && String(props.idPacienteExistente) !== '-1'
                    ? String(props.idPacienteExistente)
                    : (pacienteIdModal || '-1');
            setIdPacienteExistente(pacienteExistenteModal);
            setEstadoPaciente(
                props.estadoPaciente !== undefined && props.estadoPaciente !== null && props.estadoPaciente !== ''
                    ? String(props.estadoPaciente)
                    : ''
            );

            setPrimeraVez(props.primeraVez || false);
            setIdPacienteProximaCita(props.agendarCitaPaciente || '');
            setStepDuracionCita(props.stepCita || 15);

            setReadOnlyEstadoCita(props.bloquearEstadoCita || false);

            const isEdicionCita = Boolean(props.idCita) || Boolean(props.verCita);
            let userdataModal = null;
            if (localStorage.getItem('userdata')) {
                userdataModal = JSON.parse(localStorage.getItem('userdata'));
            }

            if (isEdicionCita) {
                // Edición: respetar quien asignó originalmente (BD). No pisar con el logueado.
                const assigneeId = props.usuarioAsigna !== undefined
                    && props.usuarioAsigna !== null
                    && String(props.usuarioAsigna) !== ''
                    ? String(props.usuarioAsigna)
                    : '';
                if (assigneeId) {
                    setIdUsuarioAsigna(assigneeId);
                    setNombreUsuarioAsigna(props.nombreUsuarioAsigna || '');
                } else if (userdataModal) {
                    setIdUsuarioAsigna(userdataModal.user_id);
                    setNombreUsuarioAsigna(`${userdataModal.user_name || ''} ${userdataModal.user_lastname || ''}`.trim());
                }
            } else if (userdataModal) {
                // Cita nueva: siempre el usuario logueado (no el de "Agenda asignada").
                setIdUsuarioAsigna(userdataModal.user_id);
                setNombreUsuarioAsigna(`${userdataModal.user_name || ''} ${userdataModal.user_lastname || ''}`.trim());
            }

            if (!props.primeraVez) {
                if (props.puedeAtender) {
                    setEstadoBtnAtender('');
                    setEstadoBtnCompletar('hide');
                } else {
                    setEstadoBtnAtender('hide');
                    setEstadoBtnCompletar('');
                }
            } else {
                setEstadoBtnAtender('hide');
                setEstadoBtnCompletar('hide');
            }

            if (props.estadoCita == 5) {
                setEstadoBtnAtender('hide');
                setReadOnlyEstadoCita(true);
            }

            if (props.verCita) {
                citaOriginalRef.current = {
                    fecha: props.fecha || '',
                    horaAtencion: props.horaAtencionCita || '',
                    minuto: props.minutoCita || '',
                    ampm: props.ampmCita || '',
                };
                estadoCitaPersistidoRef.current =
                    props.estadoCita !== undefined && props.estadoCita !== null && props.estadoCita !== ''
                        ? String(props.estadoCita)
                        : null;
            } else {
                citaOriginalRef.current = null;
                estadoCitaPersistidoRef.current = null;
            }

            setPestanaForm(props.pestanaInicial === 'planes' ? 'planes' : 'cita');
            if (props.pestanaInicial === 'planes') {
                setCrearPaciente(false);
                setCompletarDatos(false);
                setUltimaPestanaPlanes('planes');
                setMantenerPanelPlanes(true);
            } else if (!props.verCita) {
                setPlanConsumo(null);
                setMantenerPanelPlanes(false);
            }

        } else {
            cerrar();
            citaOriginalRef.current = null;
            estadoCitaPersistidoRef.current = null;
        }
    }, [
        props.modalState,
        props.idCita,
        props.fecha,
        props.horaAtencionCita,
        props.minutoCita,
        props.ampmCita,
        props.primerNombre,
        props.segundoNombre,
        props.primerApellido,
        props.segundoApellido,
        props.email,
        props.celular,
        props.tipoDocumento,
        props.numeroDocumento,
        props.duracionCita,
        props.estadoCita,
        props.unidadAtencion,
        props.idConvenios,
        props.motivoConsulta,
        props.citaPaciente,

        props.verCita,
        props.puedeAtender,
        props.estadoPaciente,
        props.idPaciente,
        props.primeraVez,
        props.agendarCitaPaciente,
        props.stepCita,
        props.bloquearEstadoCita,
        props.profesionalAsignado,
        props.usuarioAsigna,
        props.nombreUsuarioAsigna,
        props.pestanaInicial,
    ]);

    // Cuando ya existen estados en BD y el padre no mandó uno (cita nueva), fijar el primero.
    useEffect(() => {
        if (props.modalState !== 'visible' || !estadosCita.length) return;
        const sinEstadoPadre =
            props.estadoCita === undefined || props.estadoCita === null || props.estadoCita === '';
        if (sinEstadoPadre) {
            setEstadoCita((prev) => prev || estadosCita[0].id);
        }
    }, [props.modalState, estadosCita, props.estadoCita]);

    useEffect(() => {
        if (props.modalState !== 'visible' || !estadoCita) return;
        const requiereConfirmacion = estadoRequiereConfirmacionWhatsapp(estadoCita);
        setWhatsappConfirmacionAuto(requiereConfirmacion);
    }, [props.modalState, estadoCita, estadosCita]);

    // Preseleccionar agenda cuando el listado `agendas` termina de cargar (sin tocar nombres).
    useEffect(() => {
        if (props.modalState !== 'visible') return;
        let agendaPreseleccionada = '';
        if (props.profesionalAsignado !== undefined && props.profesionalAsignado !== null && String(props.profesionalAsignado) !== '') {
            agendaPreseleccionada = String(props.profesionalAsignado);
        } else if (props.nombreProfesionalAsignado && agendas.length > 0) {
            const normalizar = (txt) => (txt || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
            const nombreObjetivo = normalizar(props.nombreProfesionalAsignado);
            const agendaEncontrada = agendas.find((a) => {
                const nombreAgenda = normalizar(a.nombre);
                return nombreAgenda === nombreObjetivo || nombreAgenda.includes(nombreObjetivo) || nombreObjetivo.includes(nombreAgenda);
            });
            if (agendaEncontrada) {
                agendaPreseleccionada = String(agendaEncontrada.id);
            }
        }
        if (agendaPreseleccionada) {
            setIdUsers(agendaPreseleccionada);
        }
    }, [props.modalState, agendas, props.profesionalAsignado, props.nombreProfesionalAsignado]);

    // Cerrar resultados del buscador al hacer clic fuera del bloque búsqueda + lista.
    useEffect(() => {
        const onDocMouseDown = (ev) => {
            if (!searchResultsState) return;
            const el = refBusquedaPaciente.current;
            if (el && !el.contains(ev.target)) {
                setSearchResultsState('');
                setSearchResults([]);
                setNoResultado('none');
            }
        };
        document.addEventListener('mousedown', onDocMouseDown);
        return () => document.removeEventListener('mousedown', onDocMouseDown);
    }, [searchResultsState]);

    // Filtra en cliente (tildes, espacios extra, coincidencia por palabras) igual que ListarPacientes.
    const buscarPaciente = (termino) => {
        const valor = (termino || '').trim();
        if (valor.length <= 2) {
            setSearchResultsState('');
            setSearchResults([]);
            setNoResultado('none');
            return;
        }

        const filtrados = filtrarPacientesParaModal(listaPacientes, valor);
        setSearchResultsState('visible');
        setNoResultado(filtrados.length > 0 ? 'none' : 'block');
        setSearchResults(filtrados);
    }

    // Se resetea el formulario...
    const resetForm = () => {
        if (document.getElementById('patientSearch')) {
            document.getElementById('patientSearch').value = '';
        }
        if (document.getElementById('notificarWpp')) {
            document.getElementById('notificarWpp').checked = false;
        }
        if (document.getElementById('notificarEmail')) {
            document.getElementById('notificarEmail').checked = false;
        }
        if (document.getElementById('completarDatos')) {
            document.getElementById('completarDatos').checked = false;
        }

        setPrimerNombre('');
        setSegundoNombre('');
        setPrimerApellido('');
        setSegundoApellido('');
        setEmail('');
        setCelular('');
        setNumeroDocumento('');
        setTipoDocumento('');
        setFechaCita('');
        setDuracionCita('');
        setIdPacienteExistente('-1');
        setUnidadAtencion('');
        setIdConvenios('');
        setSearchResultsState('');
        setSearchResults([]);
        setNoResultado('none');
        setErrorlist({});
        setNotificarEmail(false);
        setNotificarWpp(false);
        setWhatsappConfirmacionAuto(false);
        setNotificarSms(false);
        setCompletarDatos(false);
        setHoraAtencionCita('');
        setMinutoCita('');
        setAmpmCita('');
        setMotivoConsulta('');
        setCitaPaciente('');

        setCrearPaciente(false);
        setEstadoPaciente('');
        setPestanaForm('cita');
        setPlanConsumo(null);
        setMantenerPanelPlanes(false);
        setUltimaPestanaPlanes('gestionar_planes');
        setIdPaciente('');
    }

    // Cuando se obtiene el paciente existente de los resultados de búsqueda
    const agregarPaciente = (id_paciente, primer_nombre, segundo_nombre, primer_apellido, segundo_apellido, email, celular, numero_documento, tipo_documento, estado, convenio) => {
        setPrimerNombre(primer_nombre != null ? String(primer_nombre) : '');
        setSegundoNombre(segundo_nombre != null ? String(segundo_nombre) : '');
        setPrimerApellido(primer_apellido != null ? String(primer_apellido) : '');
        setSegundoApellido(segundo_apellido != null ? String(segundo_apellido) : '');
        setEmail(email != null ? String(email) : '');
        setCelular(celular != null ? String(celular).slice(0, 15) : '');
        setNumeroDocumento(numero_documento != null ? String(numero_documento) : '');
        setTipoDocumento(tipo_documento != null ? String(tipo_documento) : '');
        setIdPacienteExistente(id_paciente);
        setIdPaciente(id_paciente != null && id_paciente !== '' ? String(id_paciente) : '');
        setEstadoPaciente(estado !== undefined && estado !== null && estado !== '' ? String(estado) : '');
        setIdConvenios(convenio != null && convenio !== '' && convenio !== '0' ? String(convenio) : '');
        setSearchResultsState('');
        setSearchResults([]);
        setNoResultado('none');
    }

    const handleCloseModalInfo = () => setShowModalCompletarInfo(false);
    const handleCompletarInfo = () => history.push('/configuracion');

    const handleAtenderCita = async () => {
        let userdata = {};
        if (localStorage.getItem('userdata')) userdata = JSON.parse(localStorage.getItem('userdata'));

        let pacienteIdResuelto = idPaciente;
        let estadoParaAtencion = estadoPaciente;

        // Si no hay id_paciente en el estado, intentar resolver por documento vía backend
        if (!pacienteIdResuelto && idCita) {
            try {
                const res = await axios.get('/resolver-paciente-cita', {
                    headers: { Authorization: 'Bearer ' + userdata.access_token },
                    params: { id_cita: idCita }
                });
                pacienteIdResuelto = res.data?.id_paciente || null;
                if (res.data && Object.prototype.hasOwnProperty.call(res.data, 'estado') && res.data.estado !== null && res.data.estado !== '') {
                    estadoParaAtencion = String(res.data.estado);
                    setEstadoPaciente(String(res.data.estado));
                }
            } catch (e) {
                formCitaWarn('No se pudo resolver paciente por documento:', e);
            }
        }

        if (!pacienteIdResuelto) {
            Swal.fire({
                icon: 'warning',
                title: 'Sin historia clínica',
                text: 'Esta cita no tiene un paciente vinculado ni datos de documento que coincidan con ningún paciente registrado. Para atender la cita primero debes vincular al paciente usando el buscador.',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        if (String(estadoParaAtencion) !== '1') {
            history.push('/editar-paciente?id=' + pacienteIdResuelto);
            return;
        }

        history.push('/atender-paciente?id=' + pacienteIdResuelto + '&ct=' + idCita);
    };

    const pacientePuedeAtencionDirecta = () => String(estadoPaciente) === '1';

    const rutaIrHistoria = () => {
        if (!idPaciente) return null;
        const id = encodeURIComponent(String(idPaciente));
        if (pacientePuedeAtencionDirecta()) {
            const ct = idCita != null && idCita !== '' ? encodeURIComponent(String(idCita)) : '';
            return `/atender-paciente?id=${id}&ct=${ct}`;
        }
        return `/editar-paciente?id=${id}`;
    };

    const rutaEvolucionPaciente = () => {
        if (!idPaciente) return null;
        return `/evolucion-paciente?id=${encodeURIComponent(String(idPaciente))}`;
    };

    // Acción para atender el paciente si este ya existe y su registro está completo
    const accionBtnAtenderPaciente = () => {
        if (usuarioPuedeIniciarAtencion()) {
            const toHistoria = rutaIrHistoria();
            const toEvolucion = rutaEvolucionPaciente();
            if (toHistoria && toEvolucion) {
                return (
                    <>
                        <Link to={toHistoria} className={'btn btn-primary mr-2 ' + estadoBtnAtender}>
                            Ir a Historia
                        </Link>
                        <Link to={toEvolucion} className={'btn btn-primary ' + estadoBtnAtender}>
                            Ir a Evolución
                        </Link>
                    </>
                );
            }
            return (
                <button type="button" onClick={handleAtenderCita} className={'btn btn-primary ' + estadoBtnAtender}>
                    Ir a Historia
                </button>
            );
        }

        return <button type="button" onClick={() => setShowModalCompletarInfo(true)} className="btn btn-primary">Atender cita</button>
    }

    const footerAccionAtencion = () => {
        if (!permisos.includes('atenderPacientes')) {
            return null;
        }
        const citaPermiteAtender = Boolean(puedeAtender) && !primeraVez;
        const hayPaciente = Boolean(idPaciente);
        if (citaPermiteAtender && hayPaciente && !pacientePuedeAtencionDirecta()) {
            return (
                <Link to={'/editar-paciente?id=' + idPaciente} className="btn btn-primary">
                    Completar anamnesis
                </Link>
            );
        }
        return accionBtnAtenderPaciente();
    };

    const renderBloqueDatosCita = () => (
        <>
            <div className="mb-2 p-2" style={{ border: '1px solid #e8edf3', borderRadius: '10px', background: '#fbfdff' }}>
                <strong style={{ fontSize: '0.82rem', color: '#3a4654' }}><i className="far fa-calendar-alt mr-1 text-info"></i> Datos de la Cita</strong>
            </div>
            <div className="row">
                <div className="col">
                    <div className="form-group">
                        <label htmlFor="appointmentDate">Fecha <span className="required-asterisk">*</span></label>
                        <input type="date" name="fecha_cita" className={`form-control ${hayErrorCampo('fecha_cita') ? 'is-invalid' : ''}`} id="appointmentDate" value={fechaCita} onChange={(e) => { setFechaCita(normalizeFechaInput(e.target.value)); limpiarErrorCampo('fecha_cita', 'hora_atencion_cita', 'id_unidad'); }} />
                        <div className="invalid-feedback visible">
                            {textoError(errorlist.fecha_cita)}
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="form-group">
                        <label htmlFor="appointmentTime">Hora <span className="required-asterisk">*</span></label>
                        <div className="control-hora">
                            <select name="hora_atencion_cita" className={`form-control ${hayErrorCampo('hora_atencion_cita') ? 'is-invalid' : ''}`} value={horaAtencionCita} onChange={(e) => { setHoraAtencionCita(e.target.value); limpiarErrorCampo('hora_atencion_cita', 'minuto_cita', 'ampm', 'id_unidad'); }}>
                                <option key={'hc0'} value=""></option>
                                <option key={'hc1'} value="00">00</option>
                                <option key={'hc2'} value="01">01</option>
                                <option key={'hc3'} value="02">02</option>
                                <option key={'hc4'} value="03">03</option>
                                <option key={'hc5'} value="04">04</option>
                                <option key={'hc6'} value="05">05</option>
                                <option key={'hc7'} value="06">06</option>
                                <option key={'hc8'} value="07">07</option>
                                <option key={'hc9'} value="08">08</option>
                                <option key={'hc10'} value="09">09</option>
                                <option key={'hc11'} value="10">10</option>
                                <option key={'hc12'} value="11">11</option>
                                <option key={'hc13'} value="12">12</option>
                            </select>
                            <select name="minuto_cita" className={`form-control ${hayErrorCampo('hora_atencion_cita') ? 'is-invalid' : ''}`} value={minutoCita} onChange={(e) => { setMinutoCita(e.target.value); limpiarErrorCampo('hora_atencion_cita', 'minuto_cita', 'ampm', 'id_unidad'); }}>
                                <option key={'mc0'} value=""></option>
                                <option key={'mc1'} value="00">00</option>
                                <option key={'mc2'} value="05">05</option>
                                <option key={'mc3'} value="10">10</option>
                                <option key={'mc4'} value="15">15</option>
                                <option key={'mc5'} value="20">20</option>
                                <option key={'mc6'} value="25">25</option>
                                <option key={'mc7'} value="30">30</option>
                                <option key={'mc8'} value="35">35</option>
                                <option key={'mc9'} value="40">40</option>
                                <option key={'mc10'} value="45">45</option>
                                <option key={'mc11'} value="50">50</option>
                                <option key={'mc12'} value="55">55</option>
                            </select>
                            <select name="ampm" className={`form-control ${hayErrorCampo('hora_atencion_cita') ? 'is-invalid' : ''}`} value={ampmCita} onChange={(e) => { setAmpmCita(e.target.value); limpiarErrorCampo('hora_atencion_cita', 'minuto_cita', 'ampm', 'id_unidad'); }}>
                                <option key={'am1'} value=""></option>
                                <option key={'am2'} value="am">AM</option>
                                <option key={'am3'} value="pm">PM</option>
                            </select>
                        </div>
                        <div className="invalid-feedback visible">
                            {textoError(errorlist.hora_atencion_cita)}
                            {textoError(errorlist.minuto_cita)}
                            {textoError(errorlist.ampm)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="form-group">
                        <label htmlFor="appointmentState">Estado de la Cita <span className="required-asterisk">*</span></label>
                        <select
                            name="estado_cita"
                            className={`form-control ${hayErrorCampo('estado_cita') ? 'is-invalid' : ''}`}
                            id="appointmentState"
                            value={estadoCita}
                            onChange={(e) => handleEstadoCitaChange(e.target.value)}
                            disabled={readOnlyEstadoCita}
                            required
                        >
                            <option value=""></option>
                            {estadosCita.map((estado) => (
                                <option key={`estado-${estado.id}`} value={estado.id}>
                                    {estado.nombre}
                                </option>
                            ))}
                        </select>
                        <div className="invalid-feedback visible">
                            {textoError(errorlist.estado_cita)}
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="form-group">
                        <label htmlFor="appointmentDuration">Duración <span className="required-asterisk">*</span></label>
                        <input type="number" name="duracion_cita" min={stepDuracionCita} step={stepDuracionCita} className={`form-control ${hayErrorCampo('duracion_cita') ? 'is-invalid' : ''}`} id="appointmentDuration" value={duracionCita} onChange={(e) => {
                            setDuracionCita(e.target.value);
                            limpiarErrorCampo('duracion_cita', 'hora_atencion_cita', 'id_unidad');
                        }} />
                        <div className="invalid-feedback visible">
                            {textoError(errorlist.duracion_cita)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="form-group">
                        <label htmlFor="appointmentPerson">Agenda Asignada <span className="required-asterisk">*</span></label>
                        <select name="id_users" className={`form-control ${hayErrorCampo('id_users') ? 'is-invalid' : ''}`} value={idUsers || ''} disabled={readOnlyProfesional} onChange={(e) => { setIdUsers(e.target.value); limpiarErrorCampo('id_users', 'hora_atencion_cita', 'id_unidad'); }}>
                            <option value=""></option>
                            {agendas.map((agenda) => (
                                <option key={`agenda-${agenda.id}`} value={agenda.id}>{agenda.nombre}</option>
                            ))}
                        </select>
                        <div className="invalid-feedback visible">
                            {textoError(errorlist.id_users)}
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="form-group">
                        <label htmlFor="appointmentUser">Usuario que Asigna</label>
                        <input type="text" name="id_usuario_asigna" className="form-control" id="appointmentUser" placeholder="Usuario que asigna" value={nombreUsuarioAsigna} readOnly />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="form-group">
                        <label htmlFor="appointmentUnit">Unidad de Atención</label>
                        <select name="id_unidad_atencion" className={`form-control ${hayErrorCampo('id_unidad') ? 'is-invalid' : ''}`} id="appointmentUnit" value={unidadAtencion} onChange={(e) => { setUnidadAtencion(e.target.value); limpiarErrorCampo('id_unidad', 'hora_atencion_cita'); }}>
                            <option value={''}></option>
                            {unidadesAtencion.map((unidadAtencionItem) => (
                                <option key={`unidad-${unidadAtencionItem.id}`} value={unidadAtencionItem.id}>{unidadAtencionItem.nombre_unidad}</option>
                            ))}
                        </select>
                        <div className="invalid-feedback visible">
                            {textoError(errorlist.id_unidad)}
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="form-group">
                        <label htmlFor="appointmentConvenio">Convenio</label>
                        <select name="id_convenios" className="form-control" id="appointmentConvenio" value={idConvenios} onChange={(e) => setIdConvenios(e.target.value)}>
                            <option value=""></option>
                            {convenios.map((item) => (
                                <option key={`convenio-${item.id}`} value={item.id}>{item.nombre}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="form-group">
                        <label htmlFor="appointmentReason">Motivo de Consulta</label>
                        <textarea
                            name="motivo_consulta"
                            className="form-control"
                            id="appointmentReason"
                            value={motivoConsulta}
                            onChange={(e) => setMotivoConsulta(e.target.value)}
                            rows="2"
                            placeholder="Describa el motivo de la consulta..."
                        />
                    </div>
                </div>
            </div>
            {pestanaForm !== 'planes' && (
                <div className="row">
                    {permisos.includes('crearPacientes') && idPaciente && !pacientePuedeAtencionDirecta() && (
                        <Link to={'/editar-paciente?id=' + idPaciente} className={'btn btn-primary ' + estadoBtnCompletar}>
                            Completar anamnesis
                        </Link>
                    )}
                </div>
            )}
        </>
    );


    return (
        <div>
            <div className={'modal-container modal fade in modal-nueva-cita-container form-nueva-cita ' + modalContainerStatus}>
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header modal-nueva-cita">
                            <div className="form-nueva-cita-header-bar">
                                <h4 className="modal-title mb-0">{props.tituloModal || 'Agendar Cita'}</h4>
                                {estadoCita && (
                                    <span style={getBadgeEstadoStyle()}>
                                        <span style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            backgroundColor: getColorEstadoActual(),
                                            display: 'inline-block'
                                        }}></span>
                                        {getNombreEstadoActual()}
                                    </span>
                                )}
                                <div className="form-nueva-cita-header-tabs">
                                    <button
                                        type="button"
                                        className={`btn btn-tab-cita ${pestanaForm === 'cita' ? 'btn-tab-cita-active' : ''}`}
                                        onClick={() => {
                                            setPestanaForm('cita');
                                        }}
                                    >
                                        Cita
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn btn-tab-cita ${pestanaForm === 'gestionar_planes' ? 'btn-tab-cita-active' : ''}`}
                                        onClick={() => {
                                            setPestanaForm('gestionar_planes');
                                            setUltimaPestanaPlanes('gestionar_planes');
                                            setMantenerPanelPlanes(true);
                                            setCrearPaciente(false);
                                            setCompletarDatos(false);
                                            const fechaNorm = normalizeFechaInput(props.fecha || fechaCita);
                                            if (fechaNorm) setFechaCita(fechaNorm);
                                        }}
                                    >
                                        Planes
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn btn-tab-cita ${pestanaForm === 'planes' ? 'btn-tab-cita-active' : ''}`}
                                        onClick={() => {
                                            setPestanaForm('planes');
                                            setUltimaPestanaPlanes('planes');
                                            setMantenerPanelPlanes(true);
                                            setCrearPaciente(false);
                                            setCompletarDatos(false);
                                            const fechaNorm = normalizeFechaInput(props.fecha || fechaCita);
                                            if (fechaNorm) setFechaCita(fechaNorm);
                                        }}
                                    >
                                        Asignar planes
                                    </button>
                                </div>
                            </div>
                            <button type="button" className="close" onClick={() => cerrar()}>&times;</button>
                        </div>

                        <div className="modal-body modal-nueva-cita" style={{ maxHeight: '78vh', overflowY: 'auto' }}>
                            {formSoloLectura && pestanaForm === 'cita' && motivoSoloLecturaCita === 'atendida' && (
                                <div className="alert alert-info py-2 mb-3 text-center cita-bloqueo-alert" role="alert">
                                    <i className="fas fa-lock mr-2"></i>
                                    ESTA CITA ESTÁ EN ESTADO <strong>ATENDIDA</strong> Y NO PUEDE MODIFICARSE.
                                </div>
                            )}
                            {formSoloLectura && pestanaForm === 'cita' && motivoSoloLecturaCita === 'no_cumplida' && (
                                <div className="alert alert-danger py-2 mb-3 text-center cita-bloqueo-alert" role="alert">
                                    <i className="fas fa-lock mr-2"></i>
                                    ESTA CITA ESTÁ EN ESTADO <strong>NO CUMPLIDA</strong> Y NO PUEDE MODIFICARSE.
                                </div>
                            )}
                            <form id="role-form" onSubmit={handleSubmit}>
                                <fieldset disabled={formSoloLectura && pestanaForm === 'cita'} style={{ border: 0, margin: 0, padding: 0, minWidth: 0 }}>
                                <div id="infobasica">
                                    <div className="card-body card-body-mobile">
                                        <div className="mb-2">
                                            <small className="text-muted">Los Campos Marcados con <span className="required-asterisk">*</span> son Obligatorios.</small>
                                            {(pestanaForm === 'planes' || pestanaForm === 'gestionar_planes') && errorlist.plan_consumo && (
                                                <div className="text-danger small mt-1">{textoError(errorlist.plan_consumo)}</div>
                                            )}
                                            {(pestanaForm === 'planes' || pestanaForm === 'gestionar_planes') && errorlist.id_paciente && (
                                                <div className="text-danger small mt-1">{textoError(errorlist.id_paciente)}</div>
                                            )}
                                        </div>
                                        {(pestanaForm === 'planes' || pestanaForm === 'gestionar_planes' || mantenerPanelPlanes) ? (
                                            <div
                                                className="row"
                                                style={{
                                                    display: (pestanaForm === 'planes' || pestanaForm === 'gestionar_planes')
                                                        ? 'flex'
                                                        : 'none',
                                                }}
                                            >
                                                <div className="col-12">
                                                    <FormCitaPlanesPanel
                                                        modoGestion={
                                                            pestanaForm === 'gestionar_planes'
                                                            || (pestanaForm === 'cita' && ultimaPestanaPlanes === 'gestionar_planes')
                                                        }
                                                        soloPaciente={
                                                            pestanaForm === 'planes'
                                                            || (pestanaForm === 'cita' && ultimaPestanaPlanes === 'planes')
                                                        }
                                                        idPaciente={idPaciente}
                                                        setIdPaciente={setIdPaciente}
                                                        setIdPacienteExistente={setIdPacienteExistente}
                                                        primerNombre={primerNombre}
                                                        setPrimerNombre={setPrimerNombre}
                                                        segundoNombre={segundoNombre}
                                                        setSegundoNombre={setSegundoNombre}
                                                        primerApellido={primerApellido}
                                                        setPrimerApellido={setPrimerApellido}
                                                        segundoApellido={segundoApellido}
                                                        setSegundoApellido={setSegundoApellido}
                                                        tipoDocumento={tipoDocumento}
                                                        setTipoDocumento={setTipoDocumento}
                                                        numeroDocumento={numeroDocumento}
                                                        setNumeroDocumento={setNumeroDocumento}
                                                        celular={celular}
                                                        setCelular={setCelular}
                                                        listaPacientes={listaPacientes}
                                                        planConsumo={planConsumo}
                                                        setPlanConsumo={setPlanConsumo}
                                                        idCita={idCita}
                                                        verCita={verCita}
                                                        formSoloLectura={formSoloLectura}
                                                        motivoSoloLecturaCita={motivoSoloLecturaCita}
                                                        agendas={agendas}
                                                        idUsers={idUsers}
                                                        setIdUsers={setIdUsers}
                                                        fechaCita={fechaCita}
                                                        setFechaCita={setFechaCita}
                                                        horaAtencionCita={horaAtencionCita}
                                                        setHoraAtencionCita={setHoraAtencionCita}
                                                        minutoCita={minutoCita}
                                                        setMinutoCita={setMinutoCita}
                                                        ampmCita={ampmCita}
                                                        setAmpmCita={setAmpmCita}
                                                        estadoCita={estadoCita}
                                                        handleEstadoCitaChange={handleEstadoCitaChange}
                                                        estadosCita={estadosCita}
                                                        duracionCita={duracionCita}
                                                        setDuracionCita={setDuracionCita}
                                                        stepDuracionCita={stepDuracionCita}
                                                        motivoConsulta={motivoConsulta}
                                                        setMotivoConsulta={setMotivoConsulta}
                                                        readOnlyEstadoCita={readOnlyEstadoCita}
                                                        readOnlyProfesional={readOnlyProfesional}
                                                        hayErrorCampo={hayErrorCampo}
                                                        textoError={textoError}
                                                        errorlist={errorlist}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                        {pestanaForm === 'cita' && (
                                        <div className="row">
                                            <div className="col-md-6" style={{ paddingRight: '14px' }}>
                                                <>
                                                <div className="mb-2 p-2" style={{ border: '1px solid #e8edf3', borderRadius: '10px', background: '#fbfdff' }}>
                                                    <strong style={{ fontSize: '0.82rem', color: '#3a4654' }}><i className="fas fa-user mr-1 text-info"></i> Datos del paciente</strong>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="position-relative" ref={refBusquedaPaciente}>
                                                            <div className="form-group mb-0">
                                                                <label htmlFor="patientSearch">Buscar Paciente</label>
                                                                <input
                                                                    type="search"
                                                                    name="patientSearch"
                                                                    className="form-control"
                                                                    id="patientSearch"
                                                                    placeholder="Buscar por nombre, apellido o # de documento"
                                                                    autoComplete="off"
                                                                    autoCorrect="off"
                                                                    spellCheck={false}
                                                                    autoFocus
                                                                    onChange={(e) => buscarPaciente(e.target.value)}
                                                                />
                                                            </div>
                                                            <div className={'search-bar ' + searchResultsState}>
                                                                <ul className="mb-0">
                                                                    <li key={'k0'} style={{ display: noResultado }} className="no-resultados">No se encontraron resultados...</li>
                                                                    {searchResults.map((resultado) => (
                                                                        <li key={'k' + resultado.id}>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-link btn-sm text-left p-0 text-dark text-decoration-none"
                                                                                style={{ whiteSpace: 'normal' }}
                                                                                onMouseDown={(ev) => {
                                                                                    ev.preventDefault();
                                                                                    agregarPaciente(
                                                                                        resultado.id,
                                                                                        resultado.primer_nombre,
                                                                                        resultado.segundo_nombre,
                                                                                        resultado.primer_apellido,
                                                                                        resultado.segundo_apellido,
                                                                                        resultado.email,
                                                                                        resultado.celular,
                                                                                        resultado.numero_documento,
                                                                                        resultado.tipo_documento,
                                                                                        resultado.estado,
                                                                                        resultado.convenio
                                                                                    );
                                                                                }}
                                                                            >
                                                                                {resultado.primer_nombre} {resultado.segundo_nombre} {resultado.primer_apellido} {resultado.segundo_apellido}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Campos del paciente */}
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="primer-nombre">Primer Nombre / Asunto <span className="required-asterisk">*</span></label>
                                                            <input type="text" name="primer_nombre" ref={refPrimerNombre} className={`form-control ${hayErrorCampo('primer_nombre') ? 'is-invalid' : ''}`} id="primer-nombre" placeholder="Ej. Andrea o Control postoperatorio" autoComplete="off" value={primerNombre} onChange={(e) => setPrimerNombre(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {textoError(errorlist.primer_nombre)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="segundo-nombre">Segundo Nombre</label>
                                                            <input type="text" name="segundo_nombre" ref={refSegundoNombre} className="form-control" id="segundo-nombre" autoComplete="off" value={segundoNombre} onChange={(e) => setSegundoNombre(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="primer-apellido">Primer Apellido</label>
                                                            <input type="text" name="primer_apellido" ref={refPrimerApellido} className={`form-control ${hayErrorCampo('primer_apellido') ? 'is-invalid' : ''}`} id="primer-apellido" autoComplete="off" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {textoError(errorlist.primer_apellido)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="segundo-apellido">Segundo Apellido</label>
                                                            <input type="text" name="segundo_apellido" ref={refSegundoApellido} className="form-control" id="segundo-apellido" autoComplete="off" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="email">Email</label>
                                                            <input type="email" name="email" ref={refEmail} className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {textoError(errorlist.email)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="celular">Celular</label>
                                                            <input type="text" name="celular" ref={refCelular} className={`form-control ${hayErrorCampo('celular') ? 'is-invalid' : ''}`} id="celular" value={celular} maxLength={15} onChange={(e) => setCelular(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {textoError(errorlist.celular)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="tipo-documento">Tipo de Documento</label>
                                                            <select name="tipo_documento" className={`form-control ${hayErrorCampo('tipo_documento') ? 'is-invalid' : ''}`} id="tipo-documento" ref={refTipoDocumento} value={tipoDocumento} onChange={(e) => setTipoDocumento(e.target.value)} >
                                                                <option key={'td0'} value=""></option>
                                                                {Object.keys(tiposDocumento).map((key, index) => (
                                                                    <option key={key} value={key}>{key} - {tiposDocumento[key]}</option>
                                                                ))}
                                                            </select>
                                                            <div className="invalid-feedback visible">
                                                                {textoError(errorlist.tipo_documento)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="documento">N°. de Documento</label>
                                                            <input type="text" name="numero_documento" className={`form-control ${hayErrorCampo('numero_documento') ? 'is-invalid' : ''}`} id="documento" ref={refDocumento} value={numeroDocumento} onChange={(e) => setNumeroDocumento(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {textoError(errorlist.numero_documento)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <small className="text-muted d-block mb-2">
                                                            Opcional: crear paciente, solicitar completar datos y enviar notificaciones.
                                                        </small>
                                                    </div>
                                                </div>
                                                </>
                                            </div>

                                            <div className="col-md-6 form-cita-padding">
                                                {renderBloqueDatosCita()}
                                            </div>
                                        </div>
                                        )}
                                        <div className="nueva-cita-switches">
                                            <div className="nueva-cita-switches-row">
                                                {pestanaForm === 'cita' && (
                                                <>
                                                <div className="switch-row">
                                                    <label className="custom-switch custom-switch-sm mb-0" htmlFor="crearPaciente">
                                                        <input
                                                            type="checkbox"
                                                            name="crear_paciente"
                                                            id="crearPaciente"
                                                            checked={crearPaciente || completarDatos}
                                                            disabled={completarDatos}
                                                            onChange={() => setCrearPaciente(prev => !prev)}
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label htmlFor="crearPaciente" className="mb-0">Crear Paciente</label>
                                                </div>
                                                <div className="switch-row">
                                                    <label className="custom-switch custom-switch-sm mb-0" htmlFor="completarDatos">
                                                        <input
                                                            type="checkbox"
                                                            name="completar_datos"
                                                            id="completarDatos"
                                                            checked={completarDatos}
                                                            onChange={() => {
                                                                setCompletarDatos(prev => {
                                                                    const next = !prev;
                                                                    if (next) setCrearPaciente(true);
                                                                    return next;
                                                                });
                                                            }}
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label htmlFor="completarDatos" className="mb-0">Enviar Formulario Paciente</label>
                                                </div>
                                                </>
                                                )}
                                                <div className="switch-row">
                                                    <label className="custom-switch custom-switch-sm mb-0" htmlFor="notificarWpp">
                                                        <input type="checkbox" name="notificar_wpp" id="notificarWpp" checked={notificarWpp} onChange={() => handleNotificarWpp()} />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label htmlFor="notificarWpp" className="mb-0">Notificar vía WhatsApp</label>
                                                </div>
                                                <div className="switch-row">
                                                    <label className="custom-switch custom-switch-sm mb-0" htmlFor="notificarSms">
                                                        <input type="checkbox" name="notificar_sms" id="notificarSms" checked={notificarSms} onChange={() => handleNotificarSms()} />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label htmlFor="notificarSms" className="mb-0">Notificar vía SMS</label>
                                                </div>
                                                <div className="switch-row">
                                                    <label className="custom-switch custom-switch-sm mb-0" htmlFor="notificarEmail">
                                                        <input type="checkbox" name="notificar_email" id="notificarEmail" checked={notificarEmail} onChange={() => handleNotificarEmail()} />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label htmlFor="notificarEmail" className="mb-0">Notificar vía Correo</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </fieldset>
                            </form>
                        </div>

                        <div className="modal-footer">
                            {footerAccionAtencion()}

                            {permisos.includes('crearCitas') && !formSoloLectura &&
                                <button type="button" onClick={handleSubmit} className="btn btn-primary">

                                    {verCita === true ? 'Guardar cambios' : 'Agendar Cita'}

                                    &nbsp;
                                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                </button>
                            }

                        </div>




                    </div>
                </div>
            </div>
            <div className={'modal-backdrop fade ' + modalBackdropStatus}></div>

            <Modal show={showModalCompletarInfo} onHide={handleCloseModalInfo}>
                <Modal.Header closeButton>
                    <Modal.Title>Aún no puedes atender citas</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>Para atender una cita debes completar la siguiente información:</p>
                    <ul>
                        {!usuarioTieneFirma() && <li>Firma</li>}
                        {!usuarioTieneRegistro() && <li>Registro médico</li>}
                    </ul>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalInfo}>Cancelar</Button>
                    <Button variant="primary" onClick={handleCompletarInfo}>Completar información</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
export default FormNuevaCita;